import React, { useMemo } from "react";
import Typography from "../Typography";

import { ReactComponent as LoginSvg } from "../../build/images/login.svg";
import { createJSON } from "../../utils/createJSON";
import { isJson } from "../../utils/isJson";
import { Tooltippy } from "../../actions/Tippy";
import { ReactComponent as ArrowDown } from "../../build/images/arrow_down.svg";
import { connection_platform } from "../../services/api";
import { useSelector } from "react-redux";
import unicodeToChar from "../../actions/formatUnicode";
import { Building, ExportSquare, InfoCircle, Layer } from "iconsax-reactjs";
import ReactHtmlParser from "react-html-parser";
import { dbfileSize } from "../../actions";
import { useSideDetails } from "./hooks/useSideDetails";

import "./side-details.styles.css";
import { handleCopy, treateReasonToCopy } from "../../utils/handleCopy";
import { getDescription } from "../../utils/getDescription";
import { formatarNomeDoContato } from "../../actions/websocket";
import Accordion from "../Accordion";
import TabulationContainer from "../TabulationContainer";

import { ReactComponent as TaskIcon } from "../../build/images/TabulationAssets/task.svg";

const SideDetails = ({
  selectedChat,
  openDetails,
  setOpenDetails,
  detailsOptions,
  setDetailsOptions,
  DisplayHistoric,
  historyInfo,
  ShowModals,
  tratarUnderline,
  getMediaIcon,
  buttonSearchAnotation,
  buttonSearchMarkstar,
  buttonSearchFileCompart,
}) => {
  const {
    hasEnterpriseAdditionalInfos,
    hasContactAdditionalInfos,
    MenuBot,
    MenuBotContactInfos,
    MenuBotEnterprise,
    MenuBotInformations,
    InfoUsers,
    copyFeedback,
    hasResponsavelPor,
    showCopyFeedback,
    renderDetails,
  } = useSideDetails(selectedChat);

  return (
    selectedChat &&
    openDetails && (
      <div className="container-details side-details-new">
        <div className="details-line">
          <div className="details-line__header">
            <Typography.H4 weight={700} color={"blue-selected-4"}>
              Detalhes
            </Typography.H4>
            <LoginSvg
              className="close-details"
              onClick={() => {
                setOpenDetails(false);
              }}
            />
          </div>
        </div>
        <div className="details-line details-line-no-border">
          <Typography.H4 weight={700} color={"blue-selected-4"}>
            {createJSON(formatarNomeDoContato(selectedChat.cliente))}
          </Typography.H4>
        </div>
        {/* <div className="details-line details-line-new">
          <ul className="details__info-list details__info-list-new">
            <li className="details__info-item-container">
              <span className="details__info-title">
                <Layer color="#000000" />
                <Typography.H5 color={"black"} weight={700}>
                  Dados do contato
                </Typography.H5>
              </span>
              {selectedChat.idmidia !== "3" && (
                <li className="details__info-item">
                  <span className="details__info-label">Telefone:</span>
                  <span
                    className="details__info-text"
                    onClick={(e) => {
                      const isCopied = handleCopy(selectedChat.telefone);
                      if (isCopied) {
                        showCopyFeedback(e.clientX, e.clientY);
                      }
                    }}
                  >
                    {formatarNomeDoContato(selectedChat.telefone)}
                  </span>
                </li>
              )}
              <li className="details__info-item">
                <span className="details__info-label">Data do contato: </span>
                <span
                  className="details__info-text"
                  onClick={(e) => {
                    const isCopied = handleCopy(selectedChat.datatimeatd);
                    if (isCopied) {
                      showCopyFeedback(e.clientX, e.clientY);
                    }
                  }}
                >
                  {selectedChat.datatimeatd}
                </span>
              </li>
              <li className="details__info-item">
                <span className="details__info-label">Motivo: </span>
                <span
                  className="details__info-text"
                  onClick={(e) => {
                    const isCopied = handleCopy(
                      treateReasonToCopy(
                        parseInt(selectedChat.direction) === 1
                          ? selectedChat.nomesubservico
                          : selectedChat.servico,
                      ),
                    );
                    if (isCopied) {
                      showCopyFeedback(e.clientX, e.clientY);
                    }
                  }}
                >
                  {parseInt(selectedChat.direction) === 1
                    ? selectedChat.nomesubservico
                    : selectedChat.servico}
                </span>
              </li>
              {MenuBotContactInfos.map((bot, index) => {
                const separator = bot.split(":");
                const description = getDescription(separator);
                if (separator[0]) {
                  return (
                    <li key={index} className="details__info-item">
                      <span className="details__info-label">
                        {`${createJSON(separator[0])}: `}
                      </span>
                      {description ? (
                        description.length > 21 ? (
                          <Tooltippy
                            content={
                              description.length > 21
                                ? createJSON(description)
                                : ""
                            }
                          >
                            <span
                              className="details__info-text"
                              onClick={(e) => {
                                const isCopied = handleCopy(
                                  createJSON(description),
                                );
                                if (isCopied) {
                                  showCopyFeedback(e.clientX, e.clientY);
                                }
                              }}
                            >
                              {description.length > 21
                                ? `${createJSON(description).slice(0, 21)}
                                    ...`
                                : createJSON(description)}
                            </span>
                          </Tooltippy>
                        ) : (
                          <span
                            className="details__info-text"
                            onClick={(e) => {
                              const isCopied = handleCopy(
                                createJSON(description),
                              );
                              if (isCopied) {
                                showCopyFeedback(e.clientX, e.clientY);
                              }
                            }}
                          >
                            {createJSON(description)}
                          </span>
                        )
                      ) : (
                        ""
                      )}
                    </li>
                  );
                }
              })}
              {hasContactAdditionalInfos &&
                selectedChat.contactAdditionalInfos.map((bot, index) => {
                  const separator = bot.split(":");
                  const description = getDescription(separator);

                  if (separator[0]) {
                    return (
                      <li key={index} className="details__info-item">
                        <span className="details__info-label">
                          {`${createJSON(separator[0])}: `}
                        </span>
                        {description ? (
                          description.length > 21 ? (
                            <Tooltippy
                              content={
                                description.length > 21
                                  ? createJSON(description)
                                  : ""
                              }
                            >
                              <span
                                className="details__info-text"
                                onClick={(e) => {
                                  const isCopied = handleCopy(
                                    createJSON(description),
                                  );
                                  if (isCopied) {
                                    showCopyFeedback(e.clientX, e.clientY);
                                  }
                                }}
                              >
                                {description.length > 21
                                  ? `${createJSON(description).slice(0, 21)}
                                    ...`
                                  : createJSON(description)}
                              </span>
                            </Tooltippy>
                          ) : (
                            <span
                              className="details__info-text"
                              onClick={(e) => {
                                const isCopied = handleCopy(
                                  createJSON(description),
                                );
                                if (isCopied) {
                                  showCopyFeedback(e.clientX, e.clientY);
                                }
                              }}
                            >
                              {createJSON(description)}
                            </span>
                          )
                        ) : (
                          ""
                        )}
                      </li>
                    );
                  }
                })}
            </li>
            <ul>
              <li className="details__info-item-container">
                <span className="details__info-title">
                  <Building color="#000000" />
                  <Typography.H5 color={"black"} weight={700}>
                    Dados da empresa
                  </Typography.H5>
                </span>
                {MenuBotEnterprise.map((bot, index) => {
                  const separator = bot.split(":");
                  const description = getDescription(separator);

                  if (separator[0]) {
                    return (
                      <li key={index} className="details__info-item">
                        <span className="details__info-label">
                          {`${createJSON(separator[0])}: `}
                        </span>
                        {description ? (
                          description.length > 21 ? (
                            <Tooltippy
                              content={
                                description.length > 21
                                  ? createJSON(description)
                                  : ""
                              }
                            >
                              <span
                                className="details__info-text"
                                onClick={(e) => {
                                  const isCopied = handleCopy(
                                    createJSON(description),
                                  );
                                  if (isCopied) {
                                    showCopyFeedback(e.clientX, e.clientY);
                                  }
                                }}
                              >
                                {description.length > 21
                                  ? `${createJSON(description).slice(0, 21)}
                                    ...`
                                  : createJSON(description)}
                              </span>
                            </Tooltippy>
                          ) : (
                            <span
                              className="details__info-text"
                              onClick={(e) => {
                                const isCopied = handleCopy(
                                  createJSON(description),
                                );
                                if (isCopied) {
                                  showCopyFeedback(e.clientX, e.clientY);
                                }
                              }}
                            >
                              {createJSON(description)}
                            </span>
                          )
                        ) : (
                          ""
                        )}
                      </li>
                    );
                  }
                })}
                {hasEnterpriseAdditionalInfos &&
                  selectedChat.enterpriseAdditionalInfos.map((bot, index) => {
                    const separator = bot.split(":");
                    const description = getDescription(separator);
                    if (separator[0]) {
                      return (
                        <li key={index} className="details__info-item">
                          <span className="details__info-label">
                            {`${createJSON(separator[0])}: `}
                          </span>
                          {description ? (
                            description.length > 21 ? (
                              <Tooltippy
                                content={
                                  description.length > 21
                                    ? createJSON(description)
                                    : ""
                                }
                              >
                                <span
                                  className="details__info-text"
                                  onClick={(e) => {
                                    const isCopied = handleCopy(
                                      createJSON(description),
                                    );
                                    if (isCopied) {
                                      showCopyFeedback(e.clientX, e.clientY);
                                    }
                                  }}
                                >
                                  {description.length > 21
                                    ? `${createJSON(description).slice(0, 21)}
                                    ...`
                                    : createJSON(description)}
                                </span>
                              </Tooltippy>
                            ) : (
                              <span
                                className="details__info-text"
                                onClick={(e) => {
                                  const isCopied = handleCopy(
                                    createJSON(description),
                                  );
                                  if (isCopied) {
                                    showCopyFeedback(e.clientX, e.clientY);
                                  }
                                }}
                              >
                                {createJSON(description)}
                              </span>
                            )
                          ) : (
                            ""
                          )}
                        </li>
                      );
                    }
                  })}
              </li>
            </ul>
            <li className="details__info-item-container">
              <span className="details__info-title">
                <InfoCircle color="#000000" />
                <Typography.H5 color={"black"} weight={700}>
                  Informações
                </Typography.H5>
              </span>
              <li className="details__info-item">
                <ul className="details__info-inner-list">
                  {(() => {
                    if (
                      selectedChat.protocolo !== null &&
                      selectedChat.protocolo !== undefined &&
                      selectedChat.protocolo !== ""
                    ) {
                      return (
                        <li className="details__info-inner-item">
                          <span className="details__info-inner-label">
                            {"Protocolo : "}
                          </span>
                          <span
                            className="details__info-inner-text"
                            onClick={(e) => {
                              const isCopied = handleCopy(
                                selectedChat.protocolo,
                              );
                              if (isCopied) {
                                showCopyFeedback(e.clientX, e.clientY);
                              }
                            }}
                          >
                            {selectedChat.protocolo}
                          </span>
                        </li>
                      );
                    }
                  })()}

                  {(() => {
                    if (
                      selectedChat.datatachado != undefined &&
                      selectedChat.datatachado !== "" &&
                      selectedChat.datatachado !== null
                    ) {
                      if (isJson(selectedChat.datatachado) === true) {
                        let strDtch = selectedChat.datatachado;
                        return Object.keys(strDtch).map((key) => (
                          <li className="details__info-inner-item">
                            <span className="details__info-inner-label">
                              <b>{key + ":"}</b>
                            </span>
                            <span
                              className="details__info-inner-text"
                              onClick={(e) => {
                                const isCopied = handleCopy(strDtch[key]);
                                if (isCopied) {
                                  showCopyFeedback(e.clientX, e.clientY);
                                }
                              }}
                            >
                              {strDtch[key]}
                            </span>
                          </li>
                        ));
                      }
                    }
                  })()}
                  {MenuBotInformations.map((bot, index) => {
                    const separator = bot.split(":");
                    const description = getDescription(separator);

                    if (separator[0]) {
                      return (
                        <li key={index} className="details__info-inner-item">
                          <span className="details__info-inner-label">
                            {`${createJSON(separator[0])}: `}
                          </span>
                          {description ? (
                            description.length > 21 ? (
                              <Tooltippy
                                content={
                                  description.length > 21
                                    ? createJSON(description)
                                    : ""
                                }
                              >
                                <span
                                  className="details__info-inner-text"
                                  onClick={(e) => {
                                    const isCopied = handleCopy(
                                      createJSON(description),
                                    );
                                    if (isCopied) {
                                      showCopyFeedback(e.clientX, e.clientY);
                                    }
                                  }}
                                >
                                  {description.length > 21
                                    ? `${createJSON(description).slice(0, 21)}
                                                      ...`
                                    : createJSON(description)}
                                </span>
                              </Tooltippy>
                            ) : (
                              <span
                                className="details__info-inner-text"
                                onClick={(e) => {
                                  const isCopied = handleCopy(
                                    createJSON(description),
                                  );
                                  if (isCopied) {
                                    showCopyFeedback(e.clientX, e.clientY);
                                  }
                                }}
                              >
                                {createJSON(description)}
                              </span>
                            )
                          ) : (
                            ""
                          )}
                        </li>
                      );
                    }
                  })}

                  {(() => {
                    if (
                      connection_platform.nc2_integration === true &&
                      connection_platform.nc2_users.indexOf(InfoUsers.ramal) !==
                        -1
                    ) {
                      if (
                        InfoUsers.infoclinc2.length !== 0 &&
                        selectedChat.isDialNc2
                      ) {
                        return InfoUsers.infoclinc2.map((info) => (
                          <li className="details__info-inner-item">
                            <span className="details__info-inner-label">
                              {info}
                            </span>
                          </li>
                        ));
                      }
                    }
                  })()}
                </ul>
              </li>
            </li>
          </ul>
        </div> */}
        <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
          <Accordion
            icon={<Layer size="16" color="#59697d" />}
            title="Dados do contato"
          >
            <ul className="accordion-details-body" style={{ maxWidth: "100%" }}>
              {selectedChat.idmidia !== "3" && (
                <li className="accordion-details-body__item accordion-details-body__item-v2">
                  <h3>Telefone:</h3>
                  <Tooltippy
                    content={formatarNomeDoContato(selectedChat.telefone)}
                  >
                    <span
                      onClick={(e) => {
                        const isCopied = handleCopy(selectedChat.telefone);
                        if (isCopied) {
                          showCopyFeedback(e.clientX, e.clientY);
                        }
                      }}
                    >
                      {formatarNomeDoContato(selectedChat.telefone)}
                    </span>
                  </Tooltippy>
                </li>
              )}
              <li className="accordion-details-body__item accordion-details-body__item-v2">
                <h3>Data do contato: </h3>
                <Tooltippy content={selectedChat.datatimeatd}>
                  <span
                    onClick={(e) => {
                      const isCopied = handleCopy(selectedChat.datatimeatd);
                      if (isCopied) {
                        showCopyFeedback(e.clientX, e.clientY);
                      }
                    }}
                  >
                    {selectedChat.datatimeatd}
                  </span>
                </Tooltippy>
              </li>
              <li className="accordion-details-body__item accordion-details-body__item-v2">
                <h3>Motivo: </h3>
                <Tooltippy
                  content={
                    parseInt(selectedChat.direction) === 1
                      ? selectedChat.nomesubservico
                      : selectedChat.servico
                  }
                >
                  <span
                    onClick={(e) => {
                      const isCopied = handleCopy(
                        treateReasonToCopy(
                          parseInt(selectedChat.direction) === 1
                            ? selectedChat.nomesubservico
                            : selectedChat.servico,
                        ),
                      );
                      if (isCopied) {
                        showCopyFeedback(e.clientX, e.clientY);
                      }
                    }}
                  >
                    {parseInt(selectedChat.direction) === 1
                      ? selectedChat.nomesubservico
                      : selectedChat.servico}
                  </span>
                </Tooltippy>
              </li>
              {MenuBotContactInfos.map((bot, index) => {
                const separator = bot.split(":");
                const description = getDescription(separator);
                if (separator[0]) {
                  return (
                    <li
                      key={index}
                      className="accordion-details-body__item accordion-details-body__item-v2"
                    >
                      <h3>{`${createJSON(separator[0])}: `}</h3>
                      {description ? (
                        <Tooltippy content={createJSON(description)}>
                          <span
                            onClick={(e) => {
                              const isCopied = handleCopy(
                                createJSON(description),
                              );
                              if (isCopied) {
                                showCopyFeedback(e.clientX, e.clientY);
                              }
                            }}
                          >
                            {createJSON(description)}
                          </span>
                        </Tooltippy>
                      ) : (
                        ""
                      )}
                    </li>
                  );
                }
              })}
              {hasContactAdditionalInfos &&
                selectedChat.contactAdditionalInfos.map((bot, index) => {
                  let isBodyJson = false;
                  const separator = bot.split(":");
                  const description = getDescription(separator);

                  if (separator[0]) {
                    if (
                      typeof separator[0] === "string" &&
                      separator[0].startsWith("(contentWithJson)")
                    ) {
                      isBodyJson = true;
                      separator[0] = separator[0].replace(
                        "(contentWithJson)",
                        "",
                      );
                    }
                    return (
                      <li
                        key={index}
                        className={`accordion-details-body__item ${!isBodyJson ? "accordion-details-body__item-v2" : "with-background"}`}
                      >
                        <h3>{`${createJSON(separator[0])}: `}</h3>
                        {renderDetails(description, isBodyJson)}
                        {/* {description ? (
                          <Tooltippy content={createJSON(description)}>
                            <span
                              onClick={(e) => {
                                const isCopied = handleCopy(
                                  createJSON(description),
                                );
                                if (isCopied) {
                                  showCopyFeedback(e.clientX, e.clientY);
                                }
                              }}
                            >
                              {createJSON(description)}
                            </span>
                          </Tooltippy>
                        ) : (
                          ""
                        )} */}
                      </li>
                    );
                  }
                })}
            </ul>
          </Accordion>
          <Accordion
            icon={<Building size="16" color="#59697d" />}
            title="Dados da empresa"
          >
            <ul className="accordion-details-body">
              {MenuBotEnterprise.map((bot, index) => {
                const separator = bot.split(":");
                const description = getDescription(separator);

                if (separator[0]) {
                  return (
                    <li
                      key={index}
                      className="accordion-details-body__item accordion-details-body__item-v2"
                    >
                      <h3>{`${createJSON(separator[0])}: `}</h3>
                      {description ? (
                        <Tooltippy content={createJSON(description)}>
                          <span
                            onClick={(e) => {
                              const isCopied = handleCopy(
                                createJSON(description),
                              );
                              if (isCopied) {
                                showCopyFeedback(e.clientX, e.clientY);
                              }
                            }}
                          >
                            {createJSON(description)}
                          </span>
                        </Tooltippy>
                      ) : (
                        ""
                      )}
                    </li>
                  );
                }
              })}
              {hasEnterpriseAdditionalInfos &&
                selectedChat.enterpriseAdditionalInfos.map((bot, index) => {
                  const separator = bot.split(":");
                  const description = getDescription(separator);
                  if (separator[0]) {
                    const isCompanyName =
                      separator[0] &&
                      typeof separator[0] === "string" &&
                      separator[0]
                        .toLowerCase()
                        .startsWith("empresa na agenda");
                    return (
                      <li
                        key={index}
                        className={`accordion-details-body__item accordion-details-body__item-v2 ${isCompanyName ? "accordion-details-body__item--flex-column" : ""}`}
                      >
                        <h3>{`${createJSON(isCompanyName ? "Empresa principal" : separator[0])}: `}</h3>
                        {description ? (
                          <Tooltippy content={createJSON(description)}>
                            <span
                              onClick={(e) => {
                                const isCopied = handleCopy(
                                  createJSON(description),
                                );
                                if (isCopied) {
                                  showCopyFeedback(e.clientX, e.clientY);
                                }
                              }}
                            >
                              {createJSON(description)}
                            </span>
                          </Tooltippy>
                        ) : (
                          ""
                        )}
                      </li>
                    );
                  }
                })}
              {hasResponsavelPor &&
                selectedChat.responsavelPor.map((empresa, index) => {
                  return (
                    <li
                      key={empresa.id}
                      // className="accordion-details-body__item-v2__responsavel-item accordion-details-body__item-v2__responsavel-item--with-top-separator"
                      className={`accordion-details-body__item-v2__responsavel-item ${index === 0 && hasEnterpriseAdditionalInfos ? "accordion-details-body__item-v2__responsavel-item--with-top-separator" : index !== 0 ? "accordion-details-body__item-v2__responsavel-item--with-top-separator" : ""}`}
                    >
                      <div className="accordion-details-body__item accordion-details-body__item-v2 accordion-details-body__item--flex-column">
                        <h3>Empresa: </h3>
                        <Tooltippy content={empresa.nome}>
                          <span
                            onClick={(e) => {
                              const isCopied = handleCopy(empresa.nome);
                              if (isCopied) {
                                showCopyFeedback(e.clientX, e.clientY);
                              }
                            }}
                          >
                            {empresa.nome}
                          </span>
                        </Tooltippy>
                      </div>

                      {Boolean(empresa.cnpj) && (
                        <div className="accordion-details-body__item accordion-details-body__item-v2">
                          <h3>CNPJ: </h3>
                          <Tooltippy content={empresa.cnpj}>
                            <span
                              onClick={(e) => {
                                const isCopied = handleCopy(empresa.cnpj);
                                if (isCopied) {
                                  showCopyFeedback(e.clientX, e.clientY);
                                }
                              }}
                            >
                              {empresa.cnpj}
                            </span>
                          </Tooltippy>
                        </div>
                      )}

                      {Boolean(empresa.externcode) && (
                        <div className="accordion-details-body__item accordion-details-body__item-v2">
                          <h3>Código Externo: </h3>
                          <Tooltippy content={empresa.externcode}>
                            <span
                              onClick={(e) => {
                                const isCopied = handleCopy(empresa.externcode);
                                if (isCopied) {
                                  showCopyFeedback(e.clientX, e.clientY);
                                }
                              }}
                            >
                              {empresa.externcode}
                            </span>
                          </Tooltippy>
                        </div>
                      )}
                    </li>
                  );
                })}
            </ul>
          </Accordion>
          <Accordion
            icon={<InfoCircle size="16" color="#59697d" />}
            title="Informações"
          >
            <ul className="accordion-details-body">
              {(() => {
                if (
                  selectedChat.protocolo !== null &&
                  selectedChat.protocolo !== undefined &&
                  selectedChat.protocolo !== ""
                ) {
                  return (
                    <li className="accordion-details-body__item accordion-details-body__item-v2">
                      <h3>{"Protocolo : "}</h3>
                      <Tooltippy content={selectedChat.protocolo}>
                        <span
                          onClick={(e) => {
                            const isCopied = handleCopy(selectedChat.protocolo);
                            if (isCopied) {
                              showCopyFeedback(e.clientX, e.clientY);
                            }
                          }}
                        >
                          {selectedChat.protocolo}
                        </span>
                      </Tooltippy>
                    </li>
                  );
                }
              })()}
              {(() => {
                if (
                  selectedChat.datatachado != undefined &&
                  selectedChat.datatachado !== "" &&
                  selectedChat.datatachado !== null
                ) {
                  if (isJson(selectedChat.datatachado) === true) {
                    let strDtch = selectedChat.datatachado;
                    return Object.keys(strDtch).map((key) => (
                      <li className="accordion-details-body__item accordion-details-body__item-v2">
                        <h3>
                          <b>{key + ":"}</b>
                        </h3>
                        <Tooltippy content={strDtch[key]}>
                          <span
                            onClick={(e) => {
                              const isCopied = handleCopy(strDtch[key]);
                              if (isCopied) {
                                showCopyFeedback(e.clientX, e.clientY);
                              }
                            }}
                          >
                            {strDtch[key]}
                          </span>
                        </Tooltippy>
                      </li>
                    ));
                  }
                }
              })()}
              {MenuBotInformations.map((bot, index) => {
                const separator = bot.split(":");
                const description = getDescription(separator);

                if (separator[0]) {
                  return (
                    <li
                      key={index}
                      className="accordion-details-body__item accordion-details-body__item-v2"
                    >
                      <h3>{`${createJSON(separator[0])}: `}</h3>
                      {description ? (
                        <Tooltippy content={createJSON(description)}>
                          <span
                            onClick={(e) => {
                              const isCopied = handleCopy(
                                createJSON(description),
                              );
                              if (isCopied) {
                                showCopyFeedback(e.clientX, e.clientY);
                              }
                            }}
                          >
                            {createJSON(description)}
                          </span>
                        </Tooltippy>
                      ) : (
                        ""
                      )}

                      {/* <span className="details__info-inner-text">12345</span> */}
                    </li>
                  );
                }
              })}
              {(() => {
                if (
                  connection_platform.nc2_integration === true &&
                  connection_platform.nc2_users.indexOf(InfoUsers.ramal) !== -1
                ) {
                  if (
                    InfoUsers.infoclinc2.length !== 0 &&
                    selectedChat.isDialNc2
                  ) {
                    return InfoUsers.infoclinc2.map((info) => (
                      <li className="accordion-details-body__item accordion-details-body__item-v2">
                        <span>{info}</span>
                      </li>
                    ));
                  }
                }
              })()}
            </ul>
          </Accordion>
          {/* <Accordion icon={<TaskIcon />} title="Tabulação">
            <TabulationContainer
              initialTabulationsValue={[
                { id: 1, label: "Consultas" },
                { id: 2, label: "Exames" },
                { id: 3, label: "Procedimentos" },
              ]}
            />
          </Accordion> */}
        </div>
        <div
          className={`details-line ${
            detailsOptions.interactions ? "open" : ""
          }`}
          onClick={(event) => {
            if (!detailsOptions.interactions) {
              DisplayHistoric(
                event,
                selectedChat.telefone,
                selectedChat.idatendimento,
              );
            }

            setDetailsOptions({
              ...detailsOptions,
              interactions: !detailsOptions.interactions,
            });

            ShowModals(
              event,
              "modal__agenda-pf__cliente__interacoes_history",
              selectedChat.telefone,
              selectedChat.idatendimento,
              selectedChat.cliente,
            );
          }}
        >
          <div className="details-line__header">
            <Typography.H4 weight={700} color={"blue-selected-4"}>
              Interações
            </Typography.H4>
            <ExportSquare className={`pausa-btn__icon-svg`} />
          </div>
          {/* <div
            style={{
              display: detailsOptions.interactions ? "flex" : "none",
              flexDirection: "column",
            }}
          >
            {(() => {
              if (historyInfo && historyInfo.historyRecent.length !== 0) {
                var cliente = createJSON(selectedChat.cliente);
                var mensagem = createJSON(
                  historyInfo.historyRecent[0].messagem
                );
                var idmidia = historyInfo.historyRecent[0].idmidia;
                var data_envio =
                  historyInfo.historyRecent[0].dataenvio +
                  "-" +
                  historyInfo.historyRecent[0].horaenvio;
                var agente = historyInfo.historyRecent[0].agente;
                let textFormatted = unicodeToChar(mensagem);
                textFormatted = tratarUnderline(textFormatted);
                return (
                  <div>
                    <div className="msg-fav__mp-bubble recent">
                      <div
                        className=" msg-fav__mp-bubble--recent"
                        style={{ pointerEvents: "none" }}
                      >
                        {ReactHtmlParser(`<p>${textFormatted}</p>`)}
                      </div>
                    </div>
                    <div className="anotc__mp-result-item-top padding">
                      <div className="anotc__mp-result-item-info--recent no-padding">
                        <p className="anotc__mp-result-item-name small">
                          {cliente}
                        </p>
                        {(() => {
                          if (agente === false) {
                            return (
                              <p className="anotc__mp-result-item-title small">
                                Cliente
                              </p>
                            );
                          } else {
                            return (
                              <p className="anotc__mp-result-item-title small">
                                Atendente
                              </p>
                            );
                          }
                        })()}
                      </div>
                      <div className="anotc__mp-result-item-critic med">
                        {(() => {
                          getMediaIcon(idmidia);
                        })()}

                        {data_envio}
                      </div>
                    </div>
                  </div>
                );
              }
            })()}

            <div
              className="anotc__mp-result-btn--recent"
              onClick={(event) =>
                ShowModals(
                  event,
                  "modal__agenda-pf__cliente__interacoes_history",
                  selectedChat.telefone,
                  selectedChat.idatendimento,
                  selectedChat.cliente
                )
              }
            >
              Ver tudo
            </div>
          </div> */}
        </div>
        {/* <div
          className={`details-line ${detailsOptions.notes ? "open" : ""}`}
          onClick={(e) => {
            if (!detailsOptions.notes) {
              buttonSearchAnotation(e, selectedChat.telefone);
            }
            setDetailsOptions({
              ...detailsOptions,
              notes: !detailsOptions.notes,
            });
            ShowModals(
              e,
              "modal__anotacoes-details",
              selectedChat.telefone,
              selectedChat.idatendimento,
              selectedChat.cliente
            );
          }}
        >
          <div className="details-line__header">
            <Typography.H4 weight={700} color={"blue-selected-4"}>
              Anotações
            </Typography.H4>
            <ExportSquare className={`pausa-btn__icon-svg`} />
          </div>
        </div> */}
        <div
          className={`details-line ${detailsOptions.favMsg ? "open" : ""}`}
          onClick={(e) => {
            if (!detailsOptions.favMsg) {
              buttonSearchMarkstar(e, selectedChat.telefone);
            }

            setDetailsOptions({
              ...detailsOptions,
              favMsg: !detailsOptions.favMsg,
            });
            ShowModals(
              e,
              "modal__mensagens-favoritas-details",
              selectedChat.telefone,
              selectedChat.idatendimento,
              selectedChat.cliente,
            );
          }}
        >
          <div className="details-line__header">
            <Typography.H4 weight={700} color={"blue-selected-4"}>
              Mensagens Favoritas
            </Typography.H4>
            <ExportSquare className={`pausa-btn__icon-svg`} />
          </div>
          {/* <div
            style={{
              display: detailsOptions.favMsg ? "flex" : "none",
              flexDirection: "column",
            }}
          >
            {(() => {
              if (
                DetailsMarkstar.detailsmarkstars &&
                DetailsMarkstar.detailsmarkstars.length !== 0
              ) {
                const detailsMarkstars =
                  DetailsMarkstar.detailsmarkstars.filter((details) =>
                    [1].includes(details.mimetypeid)
                  );
                var cliente = createJSON(selectedChat.cliente);
                var mensagem = detailsMarkstars[0].mensagem;
                var idmidia = detailsMarkstars[0].idmidia;
                var data_envio =
                  detailsMarkstars[0].data_markstar +
                  "-" +
                  detailsMarkstars[0].data_markstar;
                return (
                  <div>
                    <div className="msg-fav__mp-bubble recent">
                      <div className=" msg-fav__mp-bubble--recent">
                        {mensagem}
                      </div>
                      <span className="msg-fav__mp-star material-icons">
                        star
                      </span>
                    </div>
                    <div className="anotc__mp-result-item-top padding">
                      <div className="anotc__mp-result-item-info--recent no-padding">
                        <p className="anotc__mp-result-item-name small">
                          {cliente}
                        </p>
                      </div>
                      <div className="anotc__mp-result-item-critic med">
                        {data_envio}
                      </div>
                    </div>
                  </div>
                );
              }
            })()}

            <div
              className="anotc__mp-result-btn--recent"
              onClick={(event) =>
                ShowModals(
                  event,
                  "modal__mensagens-favoritas-details",
                  selectedChat.telefone,
                  selectedChat.idatendimento,
                  selectedChat.cliente
                )
              }
            >
              Ver tudo
            </div>
          </div> */}
        </div>
        <div
          className={`details-line ${
            detailsOptions.shareArchives ? "open" : ""
          }`}
          onClick={(e) => {
            if (!detailsOptions.shareArchives) {
              buttonSearchFileCompart(e, selectedChat.telefone);
            }
            setDetailsOptions({
              ...detailsOptions,
              shareArchives: !detailsOptions.shareArchives,
            });
            ShowModals(
              e,
              "modal__arquivos-compartilhados-details",
              selectedChat.telefone,
              selectedChat.idatendimento,
              selectedChat.cliente,
            );
          }}
        >
          <div className="details-line__header">
            <Typography.H4 weight={700} color={"blue-selected-4"}>
              Arquivos compartilhados
            </Typography.H4>
            <ExportSquare className={`pausa-btn__icon-svg`} />
          </div>
          {/* <div
            style={{
              display: detailsOptions.shareArchives ? "flex" : "none",
              flexDirection: "column",
            }}
          >
            {(() => {
              if (
                DetailsFileSharedIn.detailsfileshared &&
                DetailsFileSharedIn.detailsfileshared.length !== 0
              ) {
                var cliente = createJSON(selectedChat.cliente);
                var nameC =
                  DetailsFileSharedIn.detailsfileshared[0].usuario_anotacao;
                var formato = DetailsFileSharedIn.detailsfileshared[0].formato;
                var idmidia = DetailsFileSharedIn.detailsfileshared[0].idmidia;
                var data_envio =
                  DetailsFileSharedIn.detailsfileshared[0].data_envio;
                var mensagem =
                  DetailsFileSharedIn.detailsfileshared[0].mensagem;
                var tamanhourl = dbfileSize(
                  DetailsFileSharedIn.detailsfileshared[0].filesize
                );
                return (
                  <div>
                    <div className="anotc__mp-result-item-info--recent no-padding">
                      <div className="anotc__mp-result-item-info--recent__header">
                        <div className="arq-comp__t-sort">
                          <span className="arq-comp__t-sort_ft">{formato}</span>
                        </div>

                        <div className="anotc__mp-result-item-info--recent__header__title">
                          <p className="anotc__mp-result-item-name">
                            {"Arquivo em " + formato}
                          </p>
                          <p className="anotc__mp-result-item-title">
                            {tamanhourl}
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="anotc__mp-result-item-info--recent__main">
                      <div className="line">
                        <p className="anotc__mp-result-item-info--recent__main__name">
                          Data:
                        </p>
                        <p className="anotc__mp-result-item-info--recent__main__value">
                          {data_envio}
                        </p>
                      </div>
                      <div className="line">
                        <p className="anotc__mp-result-item-info--recent__main__name">
                          Canal:
                          {(() => {
                            getMediaIcon(idmidia);
                          })()}
                        </p>
                      </div>
                    </div>
                  </div>
                );
              }
            })()}

            <div
              className="anotc__mp-result-btn--recent"
              onClick={(event) =>
                ShowModals(
                  event,
                  "modal__arquivos-compartilhados-details",
                  selectedChat.telefone,
                  selectedChat.idatendimento,
                  selectedChat.cliente
                )
              }
            >
              Ver tudo
            </div>
          </div> */}
        </div>
        {Boolean(copyFeedback) && copyFeedback.visible && (
          <div
            style={{
              position: "fixed",
              left: copyFeedback.x - 170,
              top: copyFeedback.y - 70,
              transform: "translateX(-50%)",
              backgroundColor: "#FFFFFF",
              color: "#333333",
              padding: "4px 10px",
              borderRadius: "4px",
              fontSize: "12px",
              fontWeight: "bold",
              zIndex: 10000,
              pointerEvents: "none",
              border: "1px solid #e0e0e0",
              boxShadow: "0 4px 10px rgba(0, 0, 0, 0.15)",
              animation: "fadeInUp 0.3s ease-out",
            }}
          >
            Copiado
          </div>
        )}
      </div>
    )
  );
};

export default SideDetails;
